import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0,
			refetchOnWindowFocus: false,
			retry: false,
		},
	},
});
import WebSocketServiceProvider from "./context/useWebSocketDataService";
import RequestMenuServiceProvider from "./context/useRequestMenuService";
import NotesServiceProvider from "./context/useNotesService";
import PricingServiceProvider from "./context/usePricingService";
import LeaguesServiceProvider from "./context/useLeaguesDataService";
import MatchPreviewServiceProvider from "./context/useMatchPreviewService";
import BetsServiceProvider from "./context/useBetsService";
import ParketBetsServiceProvider from "./context/useParkedBetsService";
import LoggedBetsServiceProvider from "./context/useLoggedBetsService";
import RsBetsServiceProvider from "./context/useRsBetsService";
import PlayerStatsServiceProvider from "./context/usePlayerStatsService";
import SquadManagerServiceProvider from "./context/useSquadManagerService";
import SystemStatusContextProvider from "./context/useSystemStatus";
import GenericStatusContextProvider from "./context/useGenericComponentsStatus";
import UerNotificationsServiceProvider from "./context/useUserNotificationsService";
import MatchPreviewFiltersProvider from "./context/useMatchPreviewFiltersService";
import FormationPositionsServiceProvider from "./context/useFormationPositionsService";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<QueryClientProvider client={queryClient}>
	<Provider store={store}>
		<SystemStatusContextProvider>
			<WebSocketServiceProvider>
				<BrowserRouter>
					<PricingServiceProvider>
						<NotesServiceProvider>
							<RequestMenuServiceProvider>
								<LeaguesServiceProvider>
									<MatchPreviewServiceProvider>
										<BetsServiceProvider>
											<ParketBetsServiceProvider>
												<LoggedBetsServiceProvider>
													<RsBetsServiceProvider>
														<SquadManagerServiceProvider>
															<PlayerStatsServiceProvider>
																<GenericStatusContextProvider>
																	<UerNotificationsServiceProvider>
																		<MatchPreviewFiltersProvider>
																			<FormationPositionsServiceProvider>
																				<App />
																			</FormationPositionsServiceProvider>
																		</MatchPreviewFiltersProvider>
																	</UerNotificationsServiceProvider>
																</GenericStatusContextProvider>
															</PlayerStatsServiceProvider>
														</SquadManagerServiceProvider>
													</RsBetsServiceProvider>
												</LoggedBetsServiceProvider>
											</ParketBetsServiceProvider>
										</BetsServiceProvider>
									</MatchPreviewServiceProvider>
								</LeaguesServiceProvider>
							</RequestMenuServiceProvider>
						</NotesServiceProvider>
					</PricingServiceProvider>
				</BrowserRouter>
			</WebSocketServiceProvider>
		</SystemStatusContextProvider>
	</Provider>
	</QueryClientProvider>
);
